const STORAGE_PREFIX = 'pilar-widget:session:'

/**
 * Um sessionId por tenant, persistido em localStorage — é o que faz o
 * histórico (guardado no Redis do pilar-agent, por tenant+"web:"+sessionId)
 * sobreviver a um reload de página. Sem localStorage (modo privado,
 * storage bloqueado), a conversa só dura o carregamento atual — degrada,
 * não quebra.
 */
export function getSessionId(tenantId: string): string {
  const key = STORAGE_PREFIX + tenantId
  try {
    const existing = localStorage.getItem(key)
    if (existing) return existing
    const fresh = crypto.randomUUID()
    localStorage.setItem(key, fresh)
    return fresh
  } catch {
    return crypto.randomUUID()
  }
}
